/* eslint-disable jsx-a11y/label-has-associated-control */
import { Button, CircularProgress, InputAdornment, TextField, Typography } from '@material-ui/core';
import { EnvelopeSimpleIcon, InfoIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { getServiceBadgeStyle } from '../../shared/constants';
import { useStyles } from '../styles';
import { ExistingUser, ServiceOption } from '../types';

interface StepEmailProps {
  email: string;
  existingUser: ExistingUser | null;
  existingPrestations: ServiceOption[];
  checkingEmail: boolean;
  onEmailChange: (value: string) => void;
  onAddPrestation: () => void;
}

const getInitials = (user: ExistingUser) => {
  const first = (user.firstname || '').charAt(0);
  const last = (user.lastname || '').charAt(0);
  return `${first}${last}`.toUpperCase() || 'U';
};

const StepEmail: FC<StepEmailProps> = ({
  email,
  existingUser,
  existingPrestations,
  checkingEmail,
  onEmailChange,
  onAddPrestation,
}) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.field}>
        <label className={classes.label} htmlFor="beneficiary-email">
          Email
        </label>
        <TextField
          id="beneficiary-email"
          className={classes.textField}
          variant="outlined"
          value={email}
          onChange={(event) => onEmailChange(event.target.value)}
          placeholder="Adresse email"
          type="email"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {checkingEmail ? (
                  <CircularProgress size={18} />
                ) : (
                  <EnvelopeSimpleIcon size={20} color="#8B90A5" />
                )}
              </InputAdornment>
            ),
          }}
        />
      </div>

      {existingUser && (
        <div className={classes.warningBox}>
          <div className={classes.warningTitle}>
            <InfoIcon size={18} />
            <span>Attention, cette adresse mail correspond déjà à un utilisateur.</span>
          </div>
          <div className={classes.userCard}>
            {existingUser.photoUri ? (
              <img src={existingUser.photoUri} alt="" className={classes.avatar} />
            ) : (
              <div className={classes.avatar}>{getInitials(existingUser)}</div>
            )}
            <div className={classes.userMeta}>
              <Typography className={classes.userName}>
                {`${existingUser.firstname || ''} ${existingUser.lastname || ''}`.trim() ||
                  existingUser.email}
              </Typography>
              <div className={classes.badges}>
                {existingUser.rattachement === false && (
                  <span className={classes.badge} style={{ background: '#ECEEF3', color: '#5A607F' }}>
                    Non rattaché
                  </span>
                )}
                {existingPrestations.map((service) => {
                  const colors = getServiceBadgeStyle(service.id);
                  return (
                    <span
                      key={service.id}
                      className={classes.badge}
                      style={{ background: colors.background, color: colors.color }}>
                      {service.name}
                    </span>
                  );
                })}
              </div>
            </div>
            <Button className={classes.addServiceBtn} onClick={onAddPrestation}>
              Ajouter une prestation ↗
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StepEmail;
